var _radialGradient, _radialGradient2, _linearGradient, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 68.988,
    cy: 51.786,
    gradientTransform: "matrix(.707 -.707 .655 .655 -13.7 66.662)",
    gradientUnits: "userSpaceOnUse",
    r: 327.523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#716b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8863,
    stopColor: "#666069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: -22.184,
    cy: 239.017,
    gradientTransform: "matrix(1 0 0 .66 0 81.201)",
    gradientUnits: "userSpaceOnUse",
    r: 401.906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1679,
    stopColor: "#6f6872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3924,
    stopColor: "#5e5861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#615961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#514b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 322.559,
    cy: 269.825,
    gradientUnits: "userSpaceOnUse",
    r: 398.444,
    xlinkHref: "#lg1"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 309.89,
    cy: 248.823,
    gradientUnits: "userSpaceOnUse",
    r: 231.357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0322,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5523,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9638,
    stopColor: "#c6c1c8"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 332.122,
    cy: 360.103,
    gradientUnits: "userSpaceOnUse",
    r: 295.703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0541,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3005,
    stopColor: "#827983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 212.991,
    cy: 201.344,
    gradientTransform: "matrix(.707 -.707 .488 .488 -35.795 253.773)",
    gradientUnits: "userSpaceOnUse",
    r: 160.647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#fbe2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    stopColor: "#eab1b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#e9adb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8319,
    stopColor: "#e7a0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9484,
    stopColor: "#e48c92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e28086"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 190.752,
    cy: 231.559,
    gradientTransform: "matrix(.707 -.707 .488 .488 -57.042 253.528)",
    gradientUnits: "userSpaceOnUse",
    r: 200.013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7367,
    stopColor: "#69636c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 283.314,
    cy: 281.067,
    gradientTransform: "matrix(.707 -.707 .488 .488 -54.072 344.347)",
    gradientUnits: "userSpaceOnUse",
    r: 204.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544,
    stopColor: "#e4989d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5398,
    stopColor: "#da4a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#bc393d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    stopColor: "#ac3030"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 283.314,
    cy: 281.067,
    gradientTransform: "matrix(.707 -.707 .488 .488 -54.072 344.347)",
    gradientUnits: "userSpaceOnUse",
    r: 204.83,
    xlinkHref: "#lg1"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 430.73,
    cy: 1479.261,
    gradientTransform: "matrix(.931 0 0 .112 -147.994 311.003)",
    gradientUnits: "userSpaceOnUse",
    r: 230.347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0433,
    stopColor: "#aaa1ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    stopColor: "#dddae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m278.286 8.595h-44.571c-129.078 0-233.715 104.638-233.715 233.715l90.05 25.619z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.359 242.31h-73.359c0 129.077 104.637 233.714 233.714 233.714h44.571z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.286,
    cy: 242.31,
    fill: "url(#SVGID_3_)",
    r: 233.714
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.741 242.31c0 99.704-96.185 178.539-153.455 178.539-8.397 0-16.661 1.418-24.754.308-87.992-12.066-155.777-87.541-155.777-178.847s67.785-166.782 155.777-178.848c8.093-1.11 18.461 1.642 26.858 1.642 66.464.001 151.351 77.501 151.351 177.206z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.286 61.779c-8.398 0-16.661.574-24.753 1.684 87.992 12.066 155.777 87.54 155.777 178.847s-67.786 166.78-155.778 178.846c8.093 1.11 16.356 1.684 24.753 1.684 99.704 0 180.531-80.826 180.531-180.53s-80.826-180.531-180.53-180.531z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.993 145.169-137.991 56.451 28.771 6.59 136.196-63.041z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.551 339.611h26.976l66.957-137.991h-37.482z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.977 201.62 29.555 45.816 51.986 35.724 56.451-137.991z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.527 339.611 137.991-56.451-81.541-81.54z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 503.405c123.428 0 223.487-12.259 223.487-27.381h-446.974c0 15.122 100.059 27.381 223.487 27.381z",
    fill: "url(#SVGID_10_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompass);
export default __webpack_public_path__ + "static/media/icon-compass.7e1017b76f7c1c7f46bf40c8f7d38f8c.svg";
export { ForwardRef as ReactComponent };